import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { errorActions } from './actions';
import { WebAngularSharedUtilErrorHandlingConfig } from './error-handling-config';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class ErrorDispatchService {
    constructor(store, errorHandlingOptions) {
        this.store = store;
        this.errorHandlingOptions = errorHandlingOptions;
    }
    dispatch(errorInput) {
        this.store.dispatch(new errorActions.Add(errorInput));
    }
    getRedirectRoute(error) {
        if (error.redirect) {
            return error.redirectRoute || this.errorHandlingOptions.errorRedirectRoute;
        }
        return undefined;
    }
    static { this.ɵfac = function ErrorDispatchService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ErrorDispatchService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(WebAngularSharedUtilErrorHandlingConfig)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ErrorDispatchService, factory: ErrorDispatchService.ɵfac }); }
}
//# sourceMappingURL=error-dispatch.service.js.map